export default {
  WEBRTC_CONNECTION_TIMEOUT_WARNING: "Karşı katılımcı ile bağlantı kurulamaz ise, çağrı sonlandırılacak.",
  WEBRTC_DISCONNECT_WARNING:
    "Karşı katılımcı ile bağlantı kesildi. Tekrar bağlanmaya çalışılıyor, tekrar bağlantı kurulamaz ise çağrı otomatik olarak sonlandırılacak.",
  WEBRTC_CALL_HOLD_MESSAGE: "Müşteri temsilcisi görüşmeyi beklemeye aldı. En kısa sürede görüşmeye devam edilecektir.",

  GettingCallDetails: "Çağrı Detayları Alınıyor..",
  PhotoIsBeingCaptured: "Fotoğraf çekiliyor.",

  UserMediaError: "Kullanıcı Medya Hatası",
  UserMediaNotAllowedError: "Kullanıcı tarafından Kamera veya Mikrofon erişimi reddedildi.",
  UserMediaNotFoundError: "Kamera veya Mikrofon cihazı bulunamadı.",
  UserMediaNotReadableError: "Kamera başka bir uygulama tarafından zaten kullanımda.",
  UserMediaOverconstrainedError: "Belirtilen kısıtlamalar mevcut herhangi bir kamera veya mikrofon tarafından karşılanamaz.",
  UserMediaSecurityError: "Kamera veya Mikrofon erişimi güvensiz bağlamlarda izin verilmez.",
  UserMediaTypeError: "ECV tarafından sağlanan kısıtlamalar nesnesi hatalı biçimlendirilmiş veya geçersiz değerler içeriyor.",
  UserMediaUnknownError: "Bilinmeyen Kamera veya Mikrofon hatası",
  Ok: "Tamam",
  TheCallHasEnded: "Çağrı sona erdi!",

  StatusCheck: "Durum Kontrolü",
  Start: "Başlat",
  Started: "Başlatıldı",
  Copyright: "Telif Hakkı",
  AllRightsReserved: "Tüm Hakları Saklıdır.",
  ClientStatus: "Client Durumu",
  Microphone: "Mikrofon",
  Camera: "Kamera",
  TURNConnectivity: "TURN Bağlantısı",
  ECVServicesStatus: "ECV Servisler Durumu",
  QueueSocketConnectivity: "Kuyruk Socket Bağlantısı",
  SignalingSocketConnectivity: "Signaling Socket Bağlantısı",
  RecordingFailed:
    "Görüntü kaydı esnasında teknik bir hata oluşmuştur. Lütfen çağrıya devam etmeyiniz. Müşteriyi yeni bir çağrı başlatması konusunda yönlendiriniz. Takım liderinizi konu hakkında bilgilendiriniz.",
  RecordingFailedReason: "Hata mesajı: {reason}",
};
